import { render, staticRenderFns } from "./ExpandingCard.vue?vue&type=template&id=47fcacae&scoped=true&"
import script from "./ExpandingCard.vue?vue&type=script&lang=ts&"
export * from "./ExpandingCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandingCard.vue?vue&type=style&index=0&id=47fcacae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fcacae",
  null
  
)

export default component.exports